export default __webpack_public_path__ + "static/media/dataLeakageRealcase-mobile.38eea195.jpg";